<mat-form-field class="conditional__full-width" appearance="outline">
  <input
    matInput
    type="number"
    [formControl]="surveyConditionalsService.conditionForm$().get('valueToMatch') | toFormControl"
    placeholder="Type number to match on the condition"
    (keydown.enter)="$event.preventDefault()"
    (keyup.enter)="onSelectValueToMatch()"
  />
</mat-form-field>
